import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

interface LogData {
  companyName: string
  companyId: string
  companySize: string | undefined
  userEmail: string | null | undefined
  userId: string
}

interface LogItem {
  company_name: unknown
  company_id: string
  company_size: string
  user_email: string | null | undefined
  user_id: string
}

function getLogItemCommonData({
  companyName,
  companyId,
  companySize,
  userEmail,
  userId,
}: LogData): LogItem {
  return {
    company_name: companyName ?? '',
    company_id: companyId ?? '',
    company_size: companySize ?? '',
    user_email: userEmail,
    user_id: userId,
  }
}

interface PerformanceLogItem {
  name: string
  start_time_name: string
  measure_name: string
}

export function performanceLog(messageContext: PerformanceLogItem, data: LogData): void {
  const { name, start_time_name, measure_name }: PerformanceLogItem = messageContext

  const app_start_time = (
    window.performance.getEntriesByType('mark').find((el) => el.name === start_time_name) || {}
  ).startTime

  const value = (
    window.performance.getEntriesByType('measure').find((el) => el.name === measure_name) || {}
  ).duration

  datadogLogs.logger.log('browser_performance', {
    ...getLogItemCommonData(data),
    name,
    app_start_time,
    value,
  })
}

interface NetworkErrorLog {
  message: string
  requestId: string
  node: string
  releaseVersion: string
}

export function logNetworkError(messageContext: NetworkErrorLog, data: LogData): void {
  datadogLogs.logger.log('network_error', {
    ...getLogItemCommonData(data),
    ...messageContext,
  })
}

export const setFrontendModule = (module?: string) => {
  const prevModule = datadogLogs.getGlobalContext().frontend_module

  if (prevModule === module) {
    return
  }

  datadogLogs.setGlobalContextProperty('frontend_module', module)
  datadogRum.setGlobalContextProperty('frontend_module', module)

  if (window.logEvents) {
    console.log(`Changing frontend module to ${module}`)
  }
}
